import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import clsx from 'clsx'
import { createIntersectionObserver } from '../../utils/carousel'
import Item from './Item'
import placeholder from '../../../images/placeholder_acm.png'
import { Navigation } from 'swiper'
import { SwiperButton } from '../SwiperSlideButtons'
import { ChevronLeft, ChevronRight, ChevronsLeft } from 'lucide-react'

/**
 * Retorna os items formatados para serem exibidos no carousel
 *
 * @param {Array} items
 */
export const getItems = (items = []) => {
  let newItems = [],
    counter = 0,
    index = 0

  items.forEach((item) => {
    counter++

    if (counter === 3) {
      counter = 0
      newItems[index - 1].resource2 = item
      return
    }

    newItems[index] = newItems[index] || {}
    newItems[index].resource = item

    index++
  })

  return newItems
}

// Retorna os items formatados para serem exibidos no layout de grid, transformando a array de items, em uma nova array com cada elemento sendo um objeto com 2 item
export const arrangeItems = (items = []) => {
  let newItems = [],
    index = 0,
    counter = 0

  items.forEach((item) => {
    if (index % 2 === 0) {
      newItems[counter] = {}
      newItems[counter][0] = item
      counter++
    } else {
      newItems[counter - 1][1] = item
    }
    index++
  })
  return newItems
}

export default function CarouselGallery({
  items = [],
  special,
  shielded,
  premium,
  certifiedDekra,
  onItemClick,
  spinCarUrl,
  color,
}) {
  const [fullScreenModal, setFullScreenModal] = useState(false)

  return (
    <div className={clsx('carousel-gallery', { 'with-360': spinCarUrl })}>
      <div
        className={clsx('iframe-wrapper', {
          'open-full-screen': fullScreenModal,
        })}
      >
        <div
          className="iframe-wrapper__full-screen-modal-toggler"
          onClick={() => setFullScreenModal(!fullScreenModal)}
        >
          <svg
            style={{ display: fullScreenModal ? 'none' : 'block' }}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 14H2V10"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 13.9999L6.66667 9.33325"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 2H14V6"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.0002 2L9.3335 6.66667"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            style={{ display: fullScreenModal ? 'block' : 'none' }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div
          className="iframe-wrapper__full-screen-modal-overlay"
          onClick={() => setFullScreenModal(!fullScreenModal)}
        >
          <div className="iframe-wrapper__full-screen-modal-container">
            <div
              className="iframe-wrapper__full-screen-modal-toggler"
              onClick={() => setFullScreenModal(!fullScreenModal)}
            >
              <svg
                style={{ display: fullScreenModal ? 'none' : 'block' }}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 14H2V10"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 13.9999L6.66667 9.33325"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10 2H14V6"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.0002 2L9.3335 6.66667"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                style={{ display: fullScreenModal ? 'block' : 'none' }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 6L18 18"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <iframe
              src={`${spinCarUrl}!disabledrawer!lang=pt-BR!stscolor=${color}`}
              frameBorder="0"
            ></iframe>
          </div>
        </div>
        <iframe
          src={`${spinCarUrl}!disabledrawer!lang=pt-BR!stscolor=${color}`}
          frameBorder="0"
        ></iframe>
        <div className="iframe-wrapper__tag-360">
          <svg
            width="21"
            height="13"
            viewBox="0 0 21 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 0C4.8 0 0.5 2.15 0.5 5C0.5 7.45 3.69 9.38 8.21 9.88L7.79 10.29C7.69627 10.383 7.62188 10.4936 7.57111 10.6154C7.52034 10.7373 7.4942 10.868 7.4942 11C7.4942 11.132 7.52034 11.2627 7.57111 11.3846C7.62188 11.5064 7.69627 11.617 7.79 11.71C7.88296 11.8037 7.99356 11.8781 8.11542 11.9289C8.23728 11.9797 8.36799 12.0058 8.5 12.0058C8.63201 12.0058 8.76272 11.9797 8.88458 11.9289C9.00644 11.8781 9.11704 11.8037 9.21 11.71L11.21 9.71C11.301 9.6149 11.3724 9.50275 11.42 9.38C11.52 9.13654 11.52 8.86346 11.42 8.62C11.3724 8.49725 11.301 8.3851 11.21 8.29L9.21 6.29C9.0217 6.1017 8.7663 5.99591 8.5 5.99591C8.2337 5.99591 7.9783 6.1017 7.79 6.29C7.6017 6.4783 7.49591 6.7337 7.49591 7C7.49591 7.2663 7.6017 7.5217 7.79 7.71L7.91 7.82C4.5 7.34 2.5 6 2.5 5C2.5 3.78 5.62 2 10.5 2C15.38 2 18.5 3.78 18.5 5C18.5 5.83 17.05 7 14.29 7.6C14.1594 7.62503 14.035 7.67587 13.9243 7.74954C13.8135 7.82321 13.7186 7.91824 13.645 8.02906C13.5715 8.13987 13.5207 8.26425 13.4958 8.39491C13.4709 8.52557 13.4724 8.65989 13.5 8.79C13.5273 8.91884 13.5798 9.04101 13.6544 9.14951C13.7291 9.25801 13.8244 9.35069 13.935 9.42224C14.0456 9.49379 14.1692 9.54279 14.2988 9.56643C14.4283 9.59007 14.5613 9.58788 14.69 9.56C18.34 8.76 20.5 7.06 20.5 5C20.5 2.15 16.2 0 10.5 0Z"
              fill="black"
            />
          </svg>
          <span>360</span>
        </div>
      </div>
      <div className="carousel-gallery-swiper">
        <SwiperButton id="carousel-gallery-prev-button">
          <ChevronLeft strokeWidth={2} />
        </SwiperButton>
        <Swiper
          className={`${'swiper-container carousel-gallery__container'} ${
            items.length <= 2 && 'swiper-container--no-carousel'
          }`}
          modules={[Navigation]}
          loop={items.length > 10}
          navigation={{
            disabledClass: 'swiper-button--disabled',
            nextEl: '#carousel-gallery-next-button',
            prevEl: '#carousel-gallery-prev-button',
          }}
          on={
            spinCarUrl
              ? ''
              : {
                  init() {
                    createIntersectionObserver({
                      className: 'carousel-gallery__item--out',
                      items: this.slides,
                      root: this.el,
                    })
                  },
                }
          }
          slidesPerView={spinCarUrl ? 2 : 2.7}
          spaceBetween={spinCarUrl ? 8 : 15}
        >
          {spinCarUrl ? (
            arrangeItems(items).map((item, index) => (
              <SwiperSlide
                className="carousel-gallery__item--row-2"
                key={index}
              >
                <Item
                  image={item[0].image.small_webp.url}
                  onClick={onItemClick}
                  url={item[0].url}
                />
                {item[1] && (
                  <Item
                    className="carousel-gallery__item-resource--secondary"
                    image={item[1].image.small_webp.url}
                    onClick={onItemClick}
                    url={item[1].url}
                  />
                )}
              </SwiperSlide>
            ))
          ) : items.length > 0 ? (
            getItems(items).map((item, index) => (
              <SwiperSlide
                className={clsx('carousel-gallery__item', {
                  'carousel-gallery__item--row-2': item.resource2,
                  'carousel-gallery__item--unique': !item.resource2,
                })}
                key={index}
              >
                <Item
                  image={item.resource.image.small_webp.url}
                  url={item.resource.url}
                  {...(index === 0
                    ? {
                        special,
                        shielded,
                        premium,
                        certifiedDekra,
                      }
                    : {})}
                  onClick={onItemClick}
                />
                {item.resource2 && (
                  <Item
                    className="carousel-gallery__item-resource--secondary"
                    image={item.resource2.image.small_webp.url}
                    onClick={onItemClick}
                    url={item.resource2.url}
                  />
                )}
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide className="carousel-gallery__item--unique">
              <Item
                image={placeholder}
                {...{ special, shielded, premium, certifiedDekra }}
              />
            </SwiperSlide>
          )}
        </Swiper>
        <SwiperButton id="carousel-gallery-next-button">
          <ChevronRight strokeWidth={2} />
        </SwiperButton>
      </div>
    </div>
  )
}
